import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

export default function NoConnectin() {
  return (
    <div>
      <div className='no-connection-avatar'>
        <Player
          src={
            'https://assets5.lottiefiles.com/private_files/lf30_vyj97uvs.json'
          }
          className='player-lottie'
          autoplay
          loop
          speed={0.5}
          style={{}}
        />
        <span>No Available Connection</span>
      </div>
    </div>
  );
}
